import { PasswordInputIconProps } from "@/types/passwordInput";
import { FC } from "react";

const ShowPassword: FC<PasswordInputIconProps> = ({ theme }) => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke={theme}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="miter"
    >
      <path d="M2,12S5,4,12,4s10,8,10,8-2,8-10,8S2,12,2,12Z"></path>
      <circle cx="12" cy="12" r="4"></circle>
    </svg>
  );
};

export default ShowPassword;
